import {
    DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined,
} from '@ant-design/icons';
import {
    Button, Card, Form, Input, Modal, Space, Table,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import confirm from 'antd/lib/modal/confirm';
import axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';

interface IPrompt {
    id: string;
    command: string;
    name: string;
    created_at: number;
}

const AiAgentsPromptsPage = () => {
    const [form] = useForm();
    const [list, setList] = useState<IPrompt[]>([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [selected, setSelected] = useState<string>();

    const onRowDeleteConfirmed = async (record: IPrompt) => {
        setLoading(true);
        try {
            await axios({
                url: `https://ai.retechcrm.ru/api/v1/prompts/id/${record.id}/delete`,
                headers: {
                    Authorization: 'Bearer sk-4838e65ed26643738c60e8daef85d025',
                },
                method: 'DELETE',
            });
        } finally {
            getList();
        }
    };

    const onDeleteClick = (record: IPrompt) => {
        confirm({
            closable: true,
            title: 'Вы действительно хотите удалить выбранную строку?',
            onOk: () => onRowDeleteConfirmed(record),
            okType: 'danger',
            cancelText: 'Отмена',
            okText: 'Удалить',
        });
    };

    const actions = (record: IPrompt) => (
        <Space>
            <Button
                icon={<EditOutlined />}
                onClick={() => setSelected(record.id)}
                size="small"
            />
            <Button
                icon={<DeleteOutlined />}
                onClick={() => onDeleteClick(record)}
                size="small"
            />
        </Space>
    );

    const closeModal = () => setSelected(undefined);

    const getList = async () => {
        setLoading(true);
        const response = await axios({
            url: 'https://ai.retechcrm.ru/api/v1/prompts/',
            headers: {
                Authorization: 'Bearer sk-4838e65ed26643738c60e8daef85d025',
            },
        });
        if (response.status === 200 && Array.isArray(response.data)) {
            setList(response.data);
        }
        setLoading(false);
    };

    const extra = (
        <div className="card-extra-content">
            <div className="card-extra-layout-content justify-content-end">
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setSelected('new')}
                />
            </div>
        </div>
    );

    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
        if (typeof selected === 'string') {
            if (selected === 'new') {
                form.resetFields();
            } else {
                form.setFieldsValue(list.find((el) => el.id === selected));
            }
        }
    }, [selected]);

    const onSaveClick = async (values: any) => {
        const record = list.find((el) => el.id === selected);
        setSaving(true);
        const response = await axios({
            url: record instanceof Object ? `https://ai.retechcrm.ru/api/v1/prompts/id/${record.id}/update` : 'https://ai.retechcrm.ru/api/v1/prompts/create',
            headers: {
                Authorization: 'Bearer sk-4838e65ed26643738c60e8daef85d025',
            },
            method: 'POST',
            data: values,
        });
        if (response.status === 200 && Array.isArray(response.data)) {
            setList(response.data);
        }
        getList();
        setSaving(false);
        closeModal();
    };

    return (
        <>
            <Scrollbars autoHide className="scrollable-content">
                <Space className="w-100" direction="vertical">
                    <Card className="page-object-horizontal-margin" title="Список промптов" extra={extra}>
                        <Table
                            loading={loading}
                            bordered
                            dataSource={list}
                            columns={[{
                                dataIndex: 'name',
                                title: 'Наименование',
                            }, {
                                dataIndex: 'command',
                                title: 'Команда',
                                render: (val) => `/${val}`,
                            }, {
                                align: 'center',
                                dataIndex: 'created_at',
                                title: 'Дата создания',
                                render: (val) => moment.unix(val).format('DD.MM.YYYY HH:mm'),
                                width: 200,
                            }, {
                                align: 'center',
                                render: actions,
                                width: 60,
                            }]}
                            pagination={false}
                        />
                    </Card>
                </Space>
            </Scrollbars>
            <Modal
                title={selected === 'new' ? 'Новый промпт' : 'Редактирование промпта'}
                visible={typeof selected === 'string'}
                onCancel={closeModal}
                footer={null}
            >
                <Form form={form} layout="vertical" onFinish={onSaveClick}>
                    <Form.Item
                        label="Наименование"
                        name="name"
                        required
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Команда"
                        name="command"
                        required
                        rules={[{ required: true }]}
                    >
                        <Input prefix="/" />
                    </Form.Item>
                    <Form.Item
                        label="Содержание промпта"
                        name="content"
                        required
                        rules={[{ required: true }]}
                    >
                        <Input.TextArea rows={10} />
                    </Form.Item>
                    <Button
                        htmlType="submit"
                        type="primary"
                        icon={<SaveOutlined />}
                        loading={saving}
                    >
                        Сохранить
                    </Button>
                </Form>
            </Modal>
        </>
    );
};

export default AiAgentsPromptsPage;
